module.exports = __webpack_public_path__ + "img/17.88e7796d.jpeg";